import { Center, Flex, Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React from "react";
import { Outlet, Route } from "react-router-dom";

const MainLayout = () => {
  const isMobile = useMediaQuery(`(max-width: 45em)`);
  // Add Outlet
  return (
    <Center h={"100dvh"}>
      <Flex
        direction={"column"}
        h={"100%"}
        w={"100%"}
        align={"center"}
        style={{
          overflow: "auto",
          backgroundImage: "linear-gradient(to bottom, #006C85, #00323D)",
        }}
      >
        <Outlet />
      </Flex>
    </Center>
  );
};

export default MainLayout;
